import Banner from "@buildpy/ui/banner";
import { formatDate } from "@buildpy/core/lib/format";
import { statementPath } from "@buildpy/core/modules/change-order/current-statement";
import type { ContractStatementView } from "@buildpy/core/views/g2a/contract-statement";
import A4Fit from "@/modules/print/a4-fit";
import CurrentStatementDocument from "@/modules/print/current-statement-document";
import PrintPreviewShell from "@/modules/print/print-preview-shell";

// 현재 내역서 인쇄 — 같은 조직 멤버만, 화면과 같은 loadCurrentStatement 한 벌로 찍는다.
const Page = ({ data }: { data: ContractStatementView }) => {
  const { contract, grouping, result } = data;

  return (
    <PrintPreviewShell
      closeHref={statementPath(contract.id, grouping)}
      printable={result.ok}
      subtitle={contract.title}
      title={`계약 ${contract.contract_no} · 현재 내역서`}
    >
      {result.ok ? (
        <A4Fit>
          <CurrentStatementDocument
            asOf={formatDate(new Date().toISOString())}
            contractNo={contract.contract_no}
            contractTitle={contract.title}
            statement={result.loaded.statement}
          />
        </A4Fit>
      ) : (
        <Banner tone="warning">{result.message}</Banner>
      )}
    </PrintPreviewShell>
  );
};

export default Page;
